<rect width="32" height="32" rx="16" fill="currentColor" />
<g clip-path="url(#clip0_6282_312)">
    <path
        d="M17.6408 14.4643L24.9224 6H23.1969L16.8743 13.3494L11.8244 6H6L13.6364 17.1136L6 25.9897H7.72561L14.4025 18.2285L19.7355 25.9897H25.5599L17.6404 14.4643H17.6408ZM15.2773 17.2115L14.5036 16.1049L8.34737 7.29901H10.9978L15.966 14.4056L16.7397 15.5123L23.1977 24.7498H20.5473L15.2773 17.212V17.2115Z"
        fill="var(--gw-rd-white-color)"
    />
</g>
<defs>
    <clipPath id="clip0_6282_312">
        <rect
            width="19.5599"
            height="20"
            fill="var(--gw-rd-white-color)"
            transform="translate(6 6)"
        />
    </clipPath>
</defs>
